import classes from "./PatientInfoTable.module.css";

export type PatientInfoField = {
  label: string;
  /** Omitted / empty renders a blank write-in rule instead of a value. */
  value?: string;
};

interface Props {
  fields: PatientInfoField[];
  /** Cells per row. The mock-up lays the 8 header fields out 4-across, 2 rows. */
  perRow?: number;
}

/**
 * Label-above-value grid for the patient header, 4 cells per row.
 *
 * A field with no value renders as a blank write-in rule rather than an empty
 * cell, so the practitioner can fill it in by hand — which is what Weight,
 * Height, Activity Level and Goal do on payloads served without CUSTOM_DATA.
 */
const PatientInfoTable = ({ fields, perRow = 4 }: Props): JSX.Element => {
  const rows: PatientInfoField[][] = [];
  for (let i = 0; i < fields.length; i += perRow) {
    rows.push(fields.slice(i, i + perRow));
  }

  return (
    <div className={classes.grid}>
      {rows.map((row, rowIndex) => (
        <div className={classes.row} key={rowIndex}>
          {row.map((field) => (
            <div className={classes.cell} key={field.label}>
              <span className={classes.label}>{field.label}</span>
              {field.value ? (
                <span className={classes.value}>{field.value}</span>
              ) : (
                <span className={classes.blank} />
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PatientInfoTable;
